// edited 2023-12-10
    // add function concateSpans(spans)
    // inside if(thisStylePListlevel){ added p with pStyle dereived from rStyle to span
    // problem: p is block element> solve: add class li.ListParagraph>p{ display: inline;}
    // li has class "ListParagraph"
// 2025-04-14 fix span concating outerHtml no value bug


//***** helper function *****
function xmlToJson(xml) {

	// Create the return object
	var obj = {};

	if (xml.nodeType == 1) { // element
		// do attributes
		if (xml.attributes.length > 0) {
		obj["attributes"] = {};
			for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j);
        obj["attributes"][attribute.nodeName] = attribute.nodeValue;
			}
		}
	} else if (xml.nodeType == 3) { // text
		obj = xml.nodeValue;
	}

	// do children
	if (xml.hasChildNodes()) {
		for(var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i);
			var nodeName = item.nodeName;
			if (typeof(obj[nodeName]) == "undefined") {
				obj[nodeName] = xmlToJson(item);
			} else {
				if (typeof(obj[nodeName].push) == "undefined") {
					var old = obj[nodeName];
					obj[nodeName] = [];
					obj[nodeName].push(old);
				}
				obj[nodeName].push(xmlToJson(item));
			}
		}
	}
	return obj;
};
function getValOf(jsonObj,elStr){
    var el = elStr.split('.');
    for(var a=0;a<el.length;a++){
    if(jsonObj[el[a]] == undefined){
        return  false;
    }else{
        jsonObj = jsonObj[el[a]];
    }
    }
    return jsonObj;
}
function getValOf2(jsonObj,elStr){
    elStr.split('.')
    .some(function(key){
    return jsonObj[key] == undefined;
    jsonObj = jsonObj[el[a]];
    })
    return jsonObj;
}
function dumper(obj,level){
    for (var b in obj){
    if (typeof obj[b]!='string'){
    //console.log("   ".repeat(level),b)
    dumper(obj[b],level+1)
    }else{
    //console.log("   ".repeat(level),b,obj[b])
    }
    }
}
function dumper2(obj,level,get){
    for (var b in obj){
    if (typeof obj[b]!='string'){
    //console.log("   ".repeat(level),b)
    if (obj[get]!=undefined){
        //console.log(get,obj[get])
        dumper(obj[get],1)
    }
    dumper2(obj[b],level+1,get)
    }else{
    //console.log("   ".repeat(level),b,obj[b])
    if (obj[get]!=undefined){
        //console.log(obj[get])
    }
    }
    }
}

function musMe(key){
    return `\n{{#${key}}}/*{{${key}}}*/{{/${key}}}`
}
function on(key,css,val){
    return `{{#${key}}}${css} /*{{${key}${val?'.'+val:''}}}*/{{/${key}}}`
}
//rPr.vanish \n\tdisplay: none;
function onOff(key,css){
    return `{{#${key}}}{{^${key}.attributes.val}}${css} /*{{${key}.attributes.val}}*/{{/${key}.attributes.val}}{{/${key}}}`
}
//.styles.docDefaults.rPrDefault.rPr.sz

function styleJsonToCss(sJ){
    var defaultStyle = "\n\tmargin:0; "
    var pIndDefault    = "{{#docDefaults.pPrDefault.pPr.ind.attributes.firstLine}}\n\ttext-indent: calc({{docDefaults.pPrDefault.pPr.ind.attributes.firstLine}}cm / 566);{{/docDefaults.pPrDefault.pPr.ind.attributes.firstLine}}"
    // var displayinline ="display:inline;"

    var pInd    =       "{{#pPr.ind.attributes.firstLine}}\n\ttext-indent: calc({{pPr.ind.attributes.firstLine}}cm / 566);{{/pPr.ind.attributes.firstLine}}"

    var color   =       "{{#rPr.color.attributes.val}}\n\tcolor: {{rPr.color.attributes.val}};{{/rPr.color.attributes.val}}"

    var fontfamily =    "{{#rPr.rFonts.attributes.cs}}\n\tfont-family: '{{rPr.rFonts.attributes.cs}}';{{/rPr.rFonts.attributes.cs}}"

    var fontsize   =    "{{#rPr.sz.attributes.val}}\n\tfont-size: calc({{rPr.sz.attributes.val}}pt / 2);{{/rPr.sz.attributes.val}}"
    var fontsizeCs   =  "{{#rPr.szCs.attributes.val}}\n\tfont-size: calc({{rPr.szCs.attributes.val}}pt / 2);{{/rPr.szCs.attributes.val}}";

    var fontBoldCs   =  "{{#rPr.bCs}}\n\tfont-weight: bold; /*{{rPr.bCs.attributes.val}}*/{{/rPr.bCs}}";

    var fontBold = onOff('rPr.b','\n\tfont-weight: bold;')

    // var fontItalic =    "{{#rPr.i}}\n\tfont-style: italic; /*{{rPr.i.attributes.val}}*/{{/rPr.i}}"
    var fontItalic = onOff('rPr.i','\n\tfont-style: italic;')

    // var fontUnderline=  "{{#rPr.u}}\n\ttext-decoration: underline; /*{{rPr.u.attributes.val}}*/{{/rPr.u}}";
    var fontUnderline = on('rPr.u','\n\ttext-decoration: underline;')
    //var vanish     =    "{{#rPr.vanish}}{{^rPr.vanish.attributes.val}}\n\tdisplay: none; /*{{rPr.vanish.attributes.val}}*/{{/rPr.vanish.attributes.val}}{{/rPr.vanish}}";
    var vanish     = onOff('rPr.vanish','\n\tdisplay: none;')

    // key = "docDefaults.rPrDefault.rPr.lang.attributes.val"
    // var styleAttributes = `\n{{#${key}}}/*{{${key}}}*/{{/${key}}}`
    var styleAttributes = musMe("docDefaults.rPrDefault.rPr.lang.attributes.val")

    // key = "attributes"
    // var styleAttributes = `\n{{#${key}}}/*{{${key}.styleId}}, {{${key}.type}}, {{${key}.customStyle}}*/{{/${key}}}`

    var css = Mustache.to_html("{{#styles}}{{#style}}.{{attributes.styleId}}\{ " +defaultStyle+color+fontfamily+fontsizeCs+pInd+fontBold+fontItalic+fontUnderline+vanish+ " \n\}\n{{/style}}{{/styles}}", sJ)
    // var css = Mustache.to_html("{{#styles}}{{#style}}.{{attributes.styleId}}\{ " +pIndDefault+ " \n\}\n{{/style}}{{/styles}}", sJ)
    return css
}

function styleJsonToCss2(sj){
    // helper function object
    var self = {
        twipToPoint: function(key,twip){ ///console.log(arguments)
            return `${key}:`+(Number(twip)/20).toFixed(2) + 'pt;\n';
        },
        twipToCm: function(key,twip){ ///console.log(arguments)
            return `${key}:`+(Number(twip)/567).toFixed(2) + 'cm;\n' ;
        },
        fontSize: function(key,pt){ ///console.log(arguments,this)
            return `${key}:`+(Number(pt)/2).toFixed(2) + 'pt;\n';
        },
        text: function(key,val){ ///console.log(val,arguments)
            return `${key}: "${val}";\n`;
        },
        plainText: function(key,val){ ///console.log(val,arguments)
            if (!(key == 'color' && val == 'auto')){
            return `${key}: ${val};\n`;   // no ""
            }else { return ''}
        },
        underline: function(key,val){ ///console.log(val, arguments)
            if (val == undefined || val != 0){
                return `text-decoration: ${key};\n`
            }else{
                return ""
            }
        },
        ifValUndefindedOrValNot0: function(key,val){ ///console.log(val, arguments)
            if (val == undefined || val != 0){
                return `${key}: ${val};\n`
            }else{
                return ""
            }
        },
        bold: function(key,val){ ///console.log(val, arguments)
            if (val == undefined || val != '0'){
                return `${key}: ${val};\n`
            }else{
                return ""
            }
        }
    }
    // data setup
    self.cssData = {
        // spacing: {attributes:{before:"margin-top",after:"margin-bottom"}, value: self.twipToPoint},
        ind:     {attributes:{left:"margin-left",right:"margin-right",firstLine:"text-indent"}, value: self.twipToCm},
        jc:      {attributes:{val:"text-align"}, value: self.text},
        // rFonts:  {attributes:{ascii:"font-family",hAnsi:"font-family",eastAsia:"mso-fareast-font-family",cs:"mso-bidi-font-family"}, value: self.text},
        rFonts:  {attributes:{cs:"font-family"}, value: self.text},
        // color:   {attributes:{themeColor:"mso-themecolor",themeShade:"mso-themeshade",val:"color"}, value: self.plainText},
        color:   {attributes:{val:"color"}, value: self.plainText},
        // sz:      {attributes:{val:"font-size"}, value: self.fontSize},
        szCs:    {attributes:{val:"font-size"},value: self.fontSize},
        // b:       {attributes:{key:"font-weight",val:"bold"}, value: self.bold},
        bCs:     {attributes:{key:"font-weight",val:"bold"}, value: self.bold},
        // i:       {attributes:{key:"font-style",val:"italic"}, value: self.ifValUndefindedOrValNot0},
        iCs:     {attributes:{key:"font-style",val:"italic"}, value: self.ifValUndefindedOrValNot0},
        u:       {attributes:{key:"text-decoration",val:"underline"}, value: self.underline},
        vanish:  {attributes:{key:"display",val:"none"}, value: self.ifValUndefindedOrValNot0},
        // lang:    {attributes:{val:"lang",eastAsia:"eastAsia",bidi:"bidi"}, value: self.text}
    }
    // add helper and data to styleJson
    var styleJson={};
    styleJson.self = self;
    styleJson.cssGet = function(){
        var xx = "\tmargin:0;\n"
        var styleCategories = this;
        var res = "";
        // category
        ///console.log(styleCategories)
        styleCategories = Object.keys(styleCategories).length>0?styleCategories:null;
        if (styleCategories){
            for (styleCategoriesKey in styleCategories){
            // attributes
            // are we handling this? check in self.cssData
            styleAttributes = styleJson.self.cssData[styleCategoriesKey] != undefined
                ?styleCategories[styleCategoriesKey]:null;
            if (styleAttributes){
                // has attributes?
                if(styleAttributes.attributes != undefined){
                for (styleAttributesKey in styleAttributes.attributes) {
                    // attribute
                    // has this attribute?
                    if (styleJson.self.cssData[styleCategoriesKey].attributes[styleAttributesKey] != undefined){
                    styleAttribute = styleAttributes.attributes[styleAttributesKey]

                    //console.log(styleCategoriesKey, styleAttributesKey, styleAttribute)
                    key    = styleJson.self.cssData[styleCategoriesKey].attributes[styleAttributesKey]
                    value  = styleAttribute
                    res    = styleJson.self.cssData[styleCategoriesKey].value(key,value)
                    xx += res?'\t'+res:'';
                    }else{
                    // not handling
                    ///console.log(styleAttributesKey)
                    }
                }
                }else{
                // no attributes, like b,bCs
                key    = styleJson.self.cssData[styleCategoriesKey].attributes['key']
                value  = styleJson.self.cssData[styleCategoriesKey].attributes['val']
                res    = styleJson.self.cssData[styleCategoriesKey].value(key,value)
                xx += res?'\t'+res:'';
                }
            }else{
            // no attributes
            // Not handling
            ///console.log(styleCategoriesKey)

            }
            }
        }else{
        // no category
        console.log('no category')
        }
        return xx;
    }
    var pInd = "{{#pPr.ind.attributes.firstLine}}\n\ttext-indent: calc({{pPr.ind.attributes.firstLine}}cm / 566);{{/pPr.ind.attributes.firstLine}}"

    return Mustache.render("{{#styles}}{{#style}}.{{attributes.styleId}}\{\n"+pInd+"{{#rPr}}{{{cssGet}}}{{/rPr}}\}\n{{/style}}{{/styles}}",styleJson)
}
//***** helper function *****

// 2018-05-01 fixed br problem
// 2018-06-29 change to make html directly
// add to paraObj {ul: true}
// 2019-10-14 debug links not working in tables
    // only href set id not set
    // <a para="0" id="" href="#A1From" class="Hyperlink tibSabchedA"> To</a> }
    // bookmarkstart not handled in table
    // resolved:
    // get All bookmarks at the start
    // get id on bookmarkEnd
// 2021-06-24 update p routine
    // xmlToJson loses p> order so use xml and jquery to transverse
    // simplify p routine combining hyperlink, bookmark, r
  // something bookmarkStart not in p, will only add ending part
  // todo: ul>li

var defaultpPr={
    pStyle:{attributes: {val:'Normal'}},
    ind:{ left: 0, firstLineChars:0, firstLine:0 }
}
var defaultrPr={}

var first
var second
var para = 0
var thisText = ''
var temp = ""
var thisStyleR = ''
var thisStyleP = ''
var lastStyle = ""
var fldChar = false
var ldCharStr = ''
// var bookmarkStart = false
var lastIdName = ''
var tempHtml = ''
var paraObj = []
// 2018-05-01 make br global
var br = ''
var lastIsUl = false
// 2018-06-26 add table function
var lastIsTr = false
// 2018-06-27
var unhandeled = {}
//var newHtml = "";
var StyleList = {}

var firsts;
var bookmarkStart;
var bookmarks=[];
var bk = {}

// 2019-11-07
var thisStylePListlevel = false
var thisStylePListMode  = false
// var thisStylePListlevelStarted = false
var thisStylePListlevelLast = false

// 2020-05-10
var thisHref = ""
var thisHrefDoc = ""
var fldCharStr = ""
var tibText  = ""

function getAllBookmarks(obj){
    var temp = {};
    var bookmarkStart = $(obj).find('body bookmarkStart');
    bookmarkStart.each(function(i,v){ //console.log(v.id, v.getAttribute('name')
        if(v.length>0){
            for(var a=0;a<v.length;a++){
                var id    = v[a].getAttribute('id')
                var name  = v[a].getAttribute('name')
                if(!/^_/.test(name)){ //ignore auto bookmarks starting with "_"
                    temp[id]  = name;
                }
            }
        }else{
            var id    = v.getAttribute('id')
            var name  = v.getAttribute('name')
            if(
                !/^_/.test(name) //ignore auto bookmarks starting with "_"
                && !/^OLE_LINK/.test(name) //ignore auto bookmarks starting with "OLE_LINK"
            ){
                temp[id]  = name;
            }
        }
    })
    return temp;
}
// function concateSpans(spans){ // concate spans to spans "with reduce", run only if more then 2 element in spans
//     // console.log(spans)
//     if(spans.length==0)return spans
//     return [spans.reduce((accumulator, currentValue) => {
//         // console.log({accumulator})
//         // get all span elements
//             var aTags     =(accumulator.match(/(<span.+?span>)/g))
//         // get last span
//             var aLastTag = aTags.pop()
//         // join remaining spans
//             var aFirstTags=aTags.join("")
//             // console.log({aFirstTags,aLastTag})

//         // from start $ till >
//         var aTagStart =(aLastTag.match(/(<[^/].+?>)/) ?.[1]) //tagStart
//         var aText     =(aLastTag.match(/>(.+?)<\//)   ?.[1]) //text
//         var aTagEnd   =(aLastTag.match(/(<\/.+?>)/)   ?.[1]) //tagEnd

//         var cTagStart =(currentValue.match(/(^.+?>)/)  ?.[1]) //tag
//         var cText     =(currentValue.match(/>(.+?)</)  ?.[1]) //text
//         var cTagEnd   =(currentValue.match(/(<\/.+?>)/)?.[1]) //tag
//         // console.log({aFirstTags,aTagStart,aText,aTagEnd,cTagStart,cText,cTagEnd})
//         if (aTagStart==cTagStart){
//             res = aFirstTags +aTagStart + aText + cText + aTagEnd
//         }else{
//             res = accumulator + currentValue;
//         }
//         return res
//     })]
// };
// function concateSpansXX(spans) {
//     if (spans.length === 0) return spans;

//     let result = [spans[0]];

//     for (let i = 1; i < spans.length; i++) {
//         const accumulator = result[result.length - 1];

//         // Get all span elements
//         const aTags = accumulator.match(/(<span.+?span>)/g);

//         // Get last span
//         const aLastTag = aTags.pop();

//         // Join remaining spans
//         const aFirstTags = aTags ? aTags.join("") : "";

//         // From start $ till >
//         const aTagStart = aLastTag.match(/(<[^/].+?>)/)?.[1]; // Tag start
//         const aText = aLastTag.match(/>(.+?)<\//)?.[1]; // Text
//         const aTagEnd = aLastTag.match(/(<\/.+?>)/)?.[1]; // Tag end

//         const cTagStart = spans[i].match(/(^.+?>)/)?.[1]; // Tag
//         const cText = spans[i].match(/>(.+?)</)?.[1]; // Text
//         const cTagEnd = spans[i].match(/(<\/.+?>)/)?.[1]; // Tag

//         if (aTagStart === cTagStart) {
//             result[result.length - 1] = aFirstTags + aTagStart + aText + cText + aTagEnd;
//         } else {
//             result.push(spans[i]);
//         }
//     }

//     return result;
// }

// // Example usage:
// const spans = [
//     "<span class=\"tibLungA\">དེ་བཞིན་གཤེགས་པ་དེ་རྣམ་པས་ཡང་དང་ཡང་དུ་ཡིད་ལ་བྱེད་པ་དང་།</span>",
//     "<span class=\"tibLungA\"> </span>"
// ];

// const concatenatedSpans = concateSpans(spans);
// console.log(concatenatedSpans);

var wF = {
    main: function(obj){ //console.log(obj,xmlToJson(obj));
      console.log('wF.main')
      // store all bookmarks
        bookmarks = getAllBookmarks(obj); console.log(bookmarks)
      // process firsts: body>
        var tempHtml = "";
        firsts = $(obj).find('body>'); ////console.log({firsts}); // get first children in "body"
        for(var c=0;c<firsts.length;c++){
            para = c
            first = firsts[c];
            //console.log(first)
            if (typeof wF[first.tagName] == "function"){ // p,r,pPr,tbl
                //console.log('handled',first.tagName)
                tempHtml += this[first.tagName](xmlToJson(first),first);
            }else{
                //console.log('not handled first:',first.tagName, first)
            }
        }
        // console.log(tempHtml)
        return tempHtml;
     },
    p: function(p,xml){ //console.log(p,xml)//console.log('p',p,$(xml).find('>')) // bookmarkEnd, hyperlink, >
        // var tempHtml = ""
        // if(p != undefined){ //console.log({p},$(xml).find('>'))
        var start = performance.now()
            var xs = $(xml).find('>'); //console.log(xs)
            var html = "";
            var spans = [];
            var pStyle="";
            var rStyle="";
            var anchor="";
            var tooltip="";
            var t="";
            var link="";
            var bookmarkid="";
            var bookmarkname="";
            var span="";
            var temp="";
            var $x = "";
            var rId = ""
            var rel = {}
            var target = ""

            // 2025-09-02
            var paraId = xml.getAttribute('paraId')
            for(var x of xs){  //console.log(x)
                $x = $(x)
                if(x.tagName=='pPr'){ // process "pPr"
                    /* get Paragraph style */
                    pStyle  = $x.find('pStyle').attr('val')||'' // get pStyle
                    rStyle  = $x.find('rPr>rStyle').attr('val')||'' // get rStyle
                    /* check for list in pPr */
                    thisStylePListlevel = $x.find('numPr').length>0
                    if (thisStylePListlevel){
                        thisStylePListlevel = $x.find('numPr>numId').attr('val')+":"+$x.find('numPr>ilvl').attr('val')
                    }
                }else if(x.tagName=='tcPr'){
                    //console.log(p,x)

                }else if(x.tagName=='hyperlink'){ // process "hyperlink"
                    anchor  = $x.attr('anchor')
                    tooltip = $x.attr('tooltip')
                    rStyle  = $x.find('r>rPr>rStyle').attr('val')||''
                    t       = $x.find('r>t').text()
                    link    = `<a href="${target?target:''}#${anchor}" class="Hyperlink ${rStyle}"${tooltip?` title="${tooltip}"`:``}>${t?`${t}`:``}</a>`
                    spans.push(link) // create and add link to spans(p content)
                    br='link';
                    // console.log('x.hyperlink',x,link,rel,{br})

                }else if(x.tagName=='bookmarkStart'){ // process "bookmarkStart"
                    bookmarkid   = $x.attr('id')
                    if (bookmarks[bookmarkid]){
                        bookmarkname = $x.attr('name')
                        span         = `<span id="${bookmarkname}">`
                        spans.push(span) // create and add bookmarkStart part (sometime bookmarkStart not in p)
                        br='bookmark'
                        // console.log('bookmarkStart',{br})
                    }

                }else if(x.tagName=='bookmarkEnd'){ // process "bookmarkEnd"
                    bookmarkid  = $x.attr('id')
                    if(bookmarks[bookmarkid]){
                        bookmarkname = bookmarks[bookmarkid]
                        span   = `</span>`
                        spans.push(span) // create and add bookmarkEnd (what if bookmarkStart not in p?)
                        // console.log('bookmarkEnd',{br},{spans})
                    }
                }else if(x.tagName=='r'){ // process "r"
                    if (fldChar == true){
                        if($x.find('fldChar').attr('fldCharType')=='end'){
                            fldChar = false;
                            if(/HYPERLINK/.test(fldCharStr)){ //console.log('fldCharstr',xml,fldCharStr)
                                rStyle = $x.find('rPr>rStyle').attr('val')||defaultpPr.pStyle.attributes.val||'Normal'
                                // "HYPERLINK "\\\\NYINGMAMONLAM\\web\\YontenZod2018\\docx\\YontenZodSutra-Chabter01~08.docx" \l "A1023བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླ"གསུམ་པ་བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླབ་བྱའི་ལེའུ་བཤད་པ་ལ་གཉིས་ཏེ།"
                                // " HYPERLINK  \l "B730དང་པོ་ནི།" \o "དང་པོ་ནི།" བསླབ་པ་བསྲུང་ཐབས་བཤད་པ་དང་།"

                                // var re = / *HYPERLINK +"(.+?)"| *\\l +"(.*?)"| *\\o +"(.*?)"/  //"xx"[1],\l[2],\o[7],restString[8]
                                // var res = fldCharStr.split(re); //console.log(fldCharStr,res,xml)
                                // thisHrefDoc = res[1]||''
                                // // replace .docx to .html
                                // thisHrefDoc = thisHrefDoc.replace('.docx','.html').replace(/[ ;:'\-—~]/g,"_");
                                // // get docName by last element of thisHrefDoc
                                // thisHrefDoc = thisHrefDoc.split('\\').slice(-1)[0];

                                // // get thisHref usw
                                // thisHref = res[2]||res[6]||''
                                // tibText  = res[7]||res[2]||res[6]||''
                                // thisText = res[8]||res[2]||res[6]||''
                                var hrefDoc = ""
                                var href  = (temp = fldCharStr.split(/\\l "(.+?)"/),temp.length>1?temp[1]:'')
                                var title = (temp = fldCharStr.split(/\\o "(.+?)"/),temp.length>1?temp[1]:'')
                                var text  = (temp = fldCharStr.split(/" /),temp.length>1?temp.slice(-1)[0]:'')

                                console.log({bookmarkname,href,title,text})

                                spans.push(`<a para="${para-1}"${title?` title="${title}"`:''}${bookmarkname?` id="${bookmarkname}"`:''} href="${hrefDoc}#${href}" class="Hyperlink ${rStyle}">${text}</a>`);
                                // if (temp == ''){
                                //     tempHtml += a;
                                // }else{
                                //     tempHtml += `<span class="${lastStyle}">${temp}${a}</span>`;
                                //     temp = "";
                                // }
                                // console.log('fldCharstr',{xml,fldCharStr,res,thisHref,tibText,thisText})
                                // lastIdName=''
                                fldCharStr=''
                            }else if(/INCLUDEPICTURE/.test(fldCharStr)){
                                console.log('INCLUDEPICTURE',fldCharStr)

                            }else{ console.log(fldCharStr)
                                fcs = / *(.+?) /.exec(fldCharStr) // get field char string name
                                if (unhandeled[fcs] == undefined){
                                    console.log(172,'unhandled fldCharStr',fldCharStr)
                                    unhandeled[fcs] = fcs
                                }
                            }
                        }else{
                            // not fldChar.End: temp+= instrText
                            var a = $x.find('t').text()||''
                            var b = $x.find('instrText').text()||''
                            fldCharStr += a+b
                        }
                    }else{
                        // check for fldChar 'begin'
                            if ($x.find('fldChar').attr('fldCharType')=='begin'){
                                fldChar=true;
                                fldCharStr='';
                        // check for 'pict'
                            }else if ($x.find('pict').length>0){ // check for pict
                                var pictTitle = $x.find('v:shape.v:imagedata.attributes.o:title')
                                var pictStyle = $x.find('v:shape.attributes.style')
                                paraObj.push({
                                    html: `<img style="${pictStyle}" src="${pictTitle}">`
                                })
                                tempHtml += `<img style="${pictStyle}" src="${pictTitle}">`;
                        // check for drawing
                            }else if ($x.find('drawing').length>0){ console.log(x)
                                // // 1. Look for BOTH the namespace version and the prefix-free version
                                // blipNode = $x.find('pic\\:blipFill > a\\:blip, blipFill > blip');

                                // // 2. Check for the 'r:embed', 'embed' (if regex stripped the r:), or 'link' attribute
                                // id = blipNode.attr('r:embed') || blipNode.attr('embed') || blipNode.attr('link');

                                // if (id) {
                                //     // Find the target path in the relationships file
                                //     const relsXml = $.parseXML(z.file('word/_rels/document.xml.rels').asText());
                                //     const target = $(relsXml).find(`Relationship[Id="${id}"]`).attr("Target");

                                //     if (target) {
                                //         // 3. DEFENSIVE CHECK: Get the file from JSZip first
                                //         const zipFile = z.file(`word/${target}`);

                                //         if (zipFile) {
                                //             // --- IT IS AN EMBEDDED IMAGE ---

                                //             // 4. CRITICAL: Extract as ArrayBuffer (Do NOT use _data.getContent())
                                //             const imageBuffer = zipFile.asArrayBuffer();

                                //             // 5. Dynamic MIME Type
                                //             const ext = target.split('.').pop().toLowerCase();
                                //             let mimeType = 'image/jpeg';
                                //             if (ext === 'png') mimeType = 'image/png';
                                //             if (ext === 'gif') mimeType = 'image/gif';
                                //             if (ext === 'svg') mimeType = 'image/svg+xml';

                                //             const blob = new Blob([imageBuffer], { type: mimeType });
                                //             const blobUrl = URL.createObjectURL(blob);

                                //             // 6. Fix the dimension selectors to handle both namespaced and clean XML
                                //             // We look for the 'xfrm' node (transform), which holds both 'off' and 'ext'
                                //             const $xfrm = $x.find('pic\\:spPr > a\\:xfrm, spPr > xfrm, xfrm');

                                //             const offx  = $xfrm.find('a\\:off, off').attr('x');
                                //             const offy  = $xfrm.find('a\\:off, off').attr('y');
                                //             const extcx = $xfrm.find('a\\:ext, ext').attr('cx');
                                //             const extcy = $xfrm.find('a\\:ext, ext').attr('cy');

                                //             console.log("Extracted Embedded:", { id, target, offx, offy, extcx, extcy, blobUrl });

                                //             // You can now safely push this to your 'spans' array:
                                //             // spans.push(`<img src="${blobUrl}" style="width:${Number(extcx)/9525}px; height:${Number(extcy)/9525}px; position:absolute; left:${Number(offx)/9525}px; top:${Number(offy)/9525}px;">`);

                                //         } else {
                                //             // --- IT IS AN EXTERNAL LINK ---
                                //             console.warn(`Skipping externally linked image: ${target}`);
                                //         }
                                //     }
                                // }



                                // // 2020-01-03 some doc have i think embeded pic: obj.drawing.v:rect..... need to add
                                // // if obj.drawing is not v:shape ignore for now
                                // // insert and link picture

                                // // Cache the nodes so jQuery only searches for them once
                                // const $docPr = $x.find('inline > docPr');
                                // const $extent = $x.find('inline > extent');

                                // // Cleaned up paths: no more wp\: or pic\:
                                // var drawingTitle =
                                //     $x.find('cNvPr').attr('name') ||
                                //     $docPr.attr('descr') ||
                                //     $docPr.attr('name');

                                // if (drawingTitle && !/^https/.test(drawingTitle)) {
                                //     // If it's a local path (like \images\image008.jpg), format it.
                                //     // You might want to clean up backslashes here if needed!
                                //     drawingTitle = "https://tulkuajam.org/images/" + drawingTitle.split('\\').pop();
                                // }

                                // if(!/^https/.test(drawingTitle)){
                                //     drawingTitle = blobUrl
                                // }

                                // // Cleaned up paths for dimensions
                                // var drawingStyle = `width: ${(Number($extent.attr('cx')) / 9525).toFixed(3)}px; height: ${(Number($extent.attr('cy')) / 9525).toFixed(3)}px;`;

                                // console.log(drawingTitle, drawingStyle);

                                // if (drawingTitle && drawingStyle) {
                                //     spans.push(`<img style="${drawingStyle}" src="${drawingTitle}">`);
                                // } else {
                                //     console.log('drawing error', x, { drawingTitle }, { drawingStyle });
                                // }


                                
                                // 1. Declare blobUrl at the top so the whole section can see it
                                let blobUrl = null;

                                // ==========================================
                                // STEP 1: ATTEMPT TO EXTRACT EMBEDDED IMAGE
                                // ==========================================
                                const blipNode = $x.find('pic\\:blipFill > a\\:blip, blipFill > blip');
                                const id = blipNode.attr('r:embed') || blipNode.attr('embed') || blipNode.attr('link');

                                if (id) {
                                    const relsXml = $.parseXML(z.file('word/_rels/document.xml.rels').asText());
                                    const target = $(relsXml).find(`Relationship[Id="${id}"]`).attr("Target");

                                    if (target) {
                                        const zipFile = z.file(`word/${target}`);

                                        if (zipFile) {
                                            // It's an embedded image! Extract it.
                                            const imageBuffer = zipFile.asArrayBuffer();
                                            const ext = target.split('.').pop().toLowerCase();

                                            let mimeType = 'image/jpeg';
                                            if (ext === 'png') mimeType = 'image/png';
                                            if (ext === 'gif') mimeType = 'image/gif';
                                            if (ext === 'svg') mimeType = 'image/svg+xml';

                                            const blob = new Blob([imageBuffer], { type: mimeType });

                                            // Assign to our outer variable
                                            blobUrl = URL.createObjectURL(blob);
                                        } else {
                                            console.warn(`Skipping externally linked image: ${target}`);
                                        }
                                    }
                                }

                                // ==========================================
                                // STEP 2: YOUR ORIGINAL DIMENSION/FALLBACK FLOW
                                // ==========================================

                                // Cache the nodes so jQuery only searches for them once
                                const $docPr = $x.find('inline > docPr');
                                const $extent = $x.find('inline > extent');

                                // Calculate dimensions right away
                                var drawingStyle = `width: ${(Number($extent.attr('cx')) / 9525).toFixed(3)}px; height: ${(Number($extent.attr('cy')) / 9525).toFixed(3)}px;`;

                                var drawingTitle = "";

                                // Decide which URL to use
                                if (blobUrl) {
                                    // PRIORITY 1: We successfully extracted a Blob! Use it.
                                    drawingTitle = blobUrl;
                                } else {
                                    // PRIORITY 2: No Blob found. Fall back to guessing the name/description.
                                    drawingTitle = $x.find('cNvPr').attr('name') || $docPr.attr('descr') || $docPr.attr('name');

                                    // If it exists and doesn't already have an https link, append your server path
                                    if (drawingTitle && !/^https/.test(drawingTitle)) {
                                        drawingTitle = "https://tulkuajam.org/images/" + drawingTitle.split('\\').pop();
                                    }
                                }

                                // ==========================================
                                // STEP 3: RENDER TO SPANS
                                // ==========================================
                                console.log(drawingTitle, drawingStyle);

                                if (drawingTitle && drawingStyle) {
                                    spans.push(`<img style="${drawingStyle}" src="${drawingTitle}">`);
                                } else {
                                    console.log('drawing error', x, { drawingTitle }, { drawingStyle });
                                }
                        //  check for 'br>type' != ''
                            }else if ($x.find('br').attr('type')!=undefined){ //*** check for "page" break br ***//
                                // if($x.find('br').attr('type')=="page"){
                                    spans.push('<hr>')
                                // }else{
                                    // console.log('br',$x.find('br'))
                                // }
                        // else 'r'
                            }else{
                                // get rStyle
                                    rStyle = $x.find('rPr>rStyle').attr('val')||defaultpPr.pStyle.attributes.val||'Normal'
                                // get t.#text
                                    t      = $x.find('t').text()||''
                                // thisText is not empty
                                    if (t != ''){
                                        if(spans.length>0 && lastStyle == rStyle){
                                            //console.log(spans,spans[spans.length-1],br)
                                            // if(br !='' && spans[spans.length-1]=="</span>"){
                                            if(br !='' && spans[spans.length-1]=="</span>"){
                                                spans= [spans.join("")]
                                                br=''
                                                spans[spans.length-1] =
                                                    $(spans[spans.length-1]).html(
                                                        $(spans[spans.length-1]).find('span').text((i,ot)=>ot+t)?.[0]?.outerHTML
                                                    )?.[0]?.outerHTML
                                            }else{
                                                spans[spans.length-1] =
                                                    // $(spans[spans.length-1]).text((i,ot)=>ot+t)[0].outerHTML
                                                    $(spans[spans.length-1]).text((i,ot)=>ot+t)?.[0]?.outerHTML
                                            }
                                        }else{
                                            // add new span
                                            spans.push(`<span class="${rStyle}">${t}</span>`);
                                        }
                                        StyleList[rStyle] = rStyle;
                                        StyleList[pStyle] = pStyle;
                                        lastStyle         = rStyle;
                                    }
                            }
                    }
                }
            }
            // spans = concateSpans(spans); // not runing on iphone12promax
            // if (spans.length>1){ spans = concateSpans(spans); }
            // console.log({spans,pStyle,rStyle})
            if(thisStylePListlevel){
                // current pass = List>Span
                    if(thisStylePListMode==false){
                        // current mode ParaSpan
                            // <ul><li><p>span</p></li>
                                html = `<ul>\n<li listlevel="${thisStylePListlevel}" class="${pStyle}"><p class="${rStyle.replace(/A$/,'P')}">${spans.map(m=>m).join('')||'<br>'}</p></li>`;
                                thisStylePListMode=true; //ListSpan:start
                    }else{
                        // current mode ListSpan
                            if(thisStylePListlevelLast == thisStylePListlevel){ ///?????
                                // current mode LS && thisStylePListlevelLast == thisStylePListlevel
                                    // <li><p>span</p><li>       LS:mid
                                        html = `<li listlevel="${thisStylePListlevel}" class="${pStyle}"><p class="${rStyle.replace(/A$/,'P')}">${spans.map(m=>m).join('')||'<br>'}</p></li>`;
                            }else{
                                // current mode LS && thisStylePListlevelLast != thisStylePListlevel
                                    // </ul><ul>li><p>span</p><li> LS:mid:restart
                                        html = `</ul>\n<ul>\n<li listlevel="${thisStylePListlevel}" class="${pStyle}"><p class="${rStyle.replace(/A$/,'P')}">${spans.map(m=>m).join('')||'<br>'}</p></li>`;
                            }
                    }
            }else{
                // current pass = Para>Span
                    if(thisStylePListMode==true){
                        // current mode LS
                            // </ul><p>span</p>   LS:end
                                thisStylePListlevelLast = false
                                thisStylePListMode = false
                                html = `</ul><p class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</p>`;
                    }else{
                        //console.log('p 684')
                        // current mode PS
                            // <p>span</p>       PS
                                html = `<p${paraId?` paraId="${paraId}"`:``} class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</p>`;
                    }
            }
            thisStylePListlevelLast = thisStylePListlevel;
            // console.log({html})
            //console.log('performance',performance.now()-start)
            return html;
     },
    r: function(obj){ //console.log('r',obj,obj.t?obj.t['#text']:obj.t)
        var tempHtml = ""
        if (obj.length == undefined){ var runs = [obj] }else{ runs = obj} // make array of 1 element
        for (var z = 0; z < runs.length; z++){
            obj = runs[z];

            if (fldChar == true){  // read fieldchar
                if ('end' == getValOf(obj,'fldChar.attributes.fldCharType')){  // check for fldChar 'end' // means end of field Char information
                    fldChar = false; // finished reading field Char information

                    // 2018-06-02 not all fieldchar are HYPERLINK checkfirst
                    //console.log(fldCharStr)

                    // if HYPERLINK
                    if (/HYPERLINK/.test(fldCharStr)){
                        thisStyleR = getValOf(obj,'rPr.rStyle.attributes.val')||defaultpPr.pStyle.attributes.val||'Normal'
                        // "HYPERLINK "\\\\NYINGMAMONLAM\\web\\YontenZod2018\\docx\\YontenZodSutra-Chabter01~08.docx" \l "A1023བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླ"གསུམ་པ་བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླབ་བྱའི་ལེའུ་བཤད་པ་ལ་གཉིས་ཏེ།"
                        // " HYPERLINK  \l "B730དང་པོ་ནི།" \o "དང་པོ་ནི།" བསླབ་པ་བསྲུང་ཐབས་བཤད་པ་དང་།"

                        var re = / *HYPERLINK +"(.+?)"| *\\l +"(.*?)"| *\\o +"(.*?)"/  //"xx"[1],\l[2],\o[7],restString[8]
                        var res = fldCharStr.split(re); console.log(fldCharStr,res)
                        thisHrefDoc = res[1]||''
                        // replace .docx to .html
                        thisHrefDoc = thisHrefDoc.replace('.docx','.html').replace(/[ ;:'\-—~]/g,"_");
                        // get docName by last element of thisHrefDoc
                        thisHrefDoc = thisHrefDoc.split('\\').slice(-1)[0];

                        // get thisHref usw
                        thisHref = res[2]||res[6]||''
                        tibText  = res[7]||res[2]||res[6]||''
                        thisText = res[8]||res[2]||res[6]||''

                        var a =  `<a para="${para-1}" ${lastIdName?`id="${lastIdName}"`:''} href="${thisHrefDoc}#${thisHref}" class="Hyperlink ${thisStyleR}">${thisText}</a>`
                        if (temp == ''){
                            tempHtml += a;
                        }else{
                            tempHtml += `<span class="${lastStyle}">${temp}${a}</span>`;
                            temp = "";
                        }

                        lastIdName=''
                        fldCharStr=''
                    // fi HYPERLINK
                    }else if(/INCLUDEPICTURE/.test(fldCharStr)){
                        console.log('INCLUDEPICTURE')
                        thisStyleR = getValOf(obj,'rPr.rStyle.attributes.val')||defaultpPr.pStyle.attributes.val||'Normal'

                        var re = / *INCLUDEPICTURE +"(.+?)"| *\\l +"(.*?)"| *\\o +"(.*?)"/  //"xx"[1],\l[2],\o[7],restString[8]
                        var res = fldCharStr.split(re)

                        thisHrefDoc = res[1]||''
                        // replace .docx to .html
                        thisHrefDoc = thisHrefDoc.replace('.docx','.html').replace(/[ ;:'\-—~]/g,"_");
                        // get thisHref
                        thisHref = res[1].split('\\').slice(-1)[0]||''
                        tibText  = ''
                        thisText = ''

                        tempHtml += `<p class="Hyperlink ${thisStyleR}"><img src="${thisHref}"></p>`

                        // lastIdName=''
                        fldCharStr=''

                    }else{
                        fcs = / *(.+?) /.exec(fldCharStr) // get field char string name
                        if (unhandeled[fcs] == undefined){
                            console.log(172,'unhandled fldCharStr',fldCharStr)
                            unhandeled[fcs] = fcs
                        }

                    }
                }else{
                    // not fldChar.End: temp+= instrText
                    var a = getValOf(obj,'t.#text')||''
                    var b = getValOf(obj,'instrText.#text')||''
                    fldCharStr += a+b
                }
            }else{ // fldChar!=true // not read fieldchar
                // check for fldChar 'begin'
                if ('begin' == getValOf(obj,'fldChar.attributes.fldCharType')){
                    fldChar=true;
                    fldCharStr='';

                }else if (getValOf(obj,'pict')){ // check for pict
                    var pictTitle = getValOf(pict,'v:shape.v:imagedata.attributes.o:title')
                    var pictStyle = getValOf(pict,'v:shape.attributes.style')
                    paraObj.push({
                        html: `<img style="${pictStyle}" src="${pictTitle}">`
                    })
                    tempHtml += `<img style="${pictStyle}" src="${pictTitle}">`;

                }else if ('' != getValOf(obj, 'br.attributes.type')){ //*** check for page break br ***//

                    tempHtml += `<span class="${lastStyle}">${temp}</span>`

                    lastStyle = thisStyleR
                    temp = thisText

                    tempHtml += '<hr>'

                }else{
                    // get rStyle
                    thisStyleR = getValOf(obj,'rPr.rStyle.attributes.val')||defaultpPr.pStyle.attributes.val||'Normal'
                    // get t.#text
                    thisText = getValOf(obj,'t.#text')||''
                    // thisText is not empty
                    if (thisText != ''){
                        if ((lastStyle == thisStyleR || lastStyle == "") && br == ''){ //if: same style add to temp || is empty (first time)
                            temp += thisText
                            thisText=''
                            lastStyle = thisStyleR
                        }else{ //lastStyle != thisStyle || lastStyle != ""
                            if(temp != ''){ // temp != ''
                                tempHtml += `<span class="${lastStyle}">${temp}</span>`
                            }
                                // prepare this part
                                lastStyle = thisStyleR;
                                temp = thisText;
                            //*******************************//
                        }
                        StyleList[thisStyleR] = thisStyleR;
                        StyleList[thisStyleP] = thisStyleP;
                    }
                }
            }
        }
        tempHtml += temp != ''?`<span class="${lastStyle}">${temp}</span>`:'';
        temp = "";
        StyleList[thisStyleR] = thisStyleR;
        StyleList[thisStyleP] = thisStyleP;
        // return `<p class="${thisStyleP}">${tempHtml}</p>`;
        return tempHtml;

     },
    // bookmarkStart: function(bk) {
        //     return '';
        //     // 2019-10-14 bookmarkStart only gets bookmarks by id
        //     // if(bk.length>0){
        //     //     for(var a = 0;a < bk.length; a++){
        //     //         var id        = getValOf(bk,'attributes.id')||''
        //     //         var name      = getValOf(bk,'attributes.name')||''
        //     //         if(id){ bookmarks[id] = name; }
        //     //     }
        //     // }else{
        //     //     var id        = getValOf(bk,'attributes.id')||''
        //     //     var name      = getValOf(bk,'attributes.name')||''
        //     //     if(id){ bookmarks[id] = name; }
        //     // }
        // },
    mybookmarkEnd: function(bk){

        if(bk.length>0){
            for(var a=0;a<bk.length;a++){
                var id = getValOf(bk[a],'attributes.id')||''
                if(!/^_/.test(bookmarks[id])){
                    lastIdName = bookmarks[id];
                }
            }
        }else{
            var id = getValOf(bk,'attributes.id')||''
            if(!/^_/.test(bookmarks[id])){
                lastIdName = bookmarks[id];
            }
        }
        if (temp != ''){
            tempHtml += `<span class="${thisStyleR}">${temp}</span>`
            temp=''
            lastStyle = thisStyleR
        }
        return tempHtml||''
     },
    myhyperlink: function(Hyper) { console.log({Hyper}) // hyperlink
        var tempHtml = ""
        if (Hyper != undefined){
            // var Hyper = ee
            var mythisHrefDoc = ""
            var mythisHref    = getValOf(Hyper,'attributes.anchor')||''
            var mythisTooltip = getValOf(Hyper,'attributes.tooltip')||''
            var mythisText    = ""
            var mythisStyleR  = ""
            if(Hyper.r.length>0){
                mythisStyleR      = getValOf(Hyper.r[0],'rPr.rStyle.attributes.val')||''
                for(var hr=0;hr<Hyper.r.length;hr++){
                    mythisText        += getValOf(Hyper.r[hr],'t.#text')||''
                }
            }else{
                mythisStyleR      = getValOf(Hyper,'r.rPr.rStyle.attributes.val')||''
                mythisText        = getValOf(Hyper,'r.t.#text')||''
            }
            // thisStyleR      = getValOf(Hyper,'r.rPr.rStyle.attributes.val')||''
            // thisText        = getValOf(Hyper,'r.t.#text')||''
        //***************** hyperlink  ************************************//
            tempHtml += `<a ${lastIdName?`id="${lastIdName}"`:''} href="${mythisHrefDoc}#${mythisHref}" class="${mythisStyleR}" title="${mythisTooltip}">${mythisText}</a>`
            lastIdName=""

            lastStyle=mythisStyleR
        //*****************            ************************************//
        }
        // console.log(tempHtml)
        return tempHtml;
     },
    // fake handler
    //sectPr: function(){},
    pPr: function(paraStyle){ //console.log(paraStyle);
        if (paraStyle.pStyle == undefined) { paraStyle.pStyle = { attributes:{val:"Normal"} } }
        defaultpPr = paraStyle
     },
    tbl: function(tbl,xml){ console.log(tbl,xml)
        var that = this;
        var tempHtml = ""
        var table = {}
        for (v in tbl){
            if (v == 'tblPr'){
                tblPr = tbl[v]
                console.log(tblPr.tblW.attributes.w,(Number(tblPr.tblW.attributes.w)/567).toPrecision(3)+"cm")
                table.width = (Number(tblPr.tblW.attributes.w)/567).toPrecision(3)+"cm"
                //console.log(tblPr)

            }else if (v == 'tblGrid'){
                tblGrid = tbl[v];
                table.colWidths = tblGrid.gridCol.map(function(v){
                    console.log(v.attributes.w,(Number(v.attributes.w)/567).toPrecision(3)+"cm");
                    return (Number(v.attributes.w)/567).toPrecision(3)+"cm"
                })
                //console.log(tblGrid)

            }else if (v == 'tr'){
                tr = tbl[v] //trs
                for (var b=0;b<tr.length;b++){ // tr b
                    trxml = $(xml).find('tr')[b]

                    // table row
                    tempHtml += "<tr>"
                    for (var a=0;a<tr[b].tc.length;a++){ // tc=td a
                        // console.log(tr[b].tc[a])
                        var tcxml = $(trxml).find('tc')[a]

                        // table column
                        tempHtml += `<td style="width:${table.colWidths[a]}">`
                            // table runs
                            xs = $(tcxml).find('>'); //console.log(xs) // content of tc seralized in xs
                            for(var x of xs){  //console.log(x)
                                $x = $(x)
                                if(x.tagName=='bookmarkStart'){
                                    this.bookmarkStart(tr[b].tc[a].bookmarkStart) //console.log(p.bookmarkStart.attributes.name,lastIdName)

                                }else if(x.tagName=='tcPr'){
                                    var tcPrxml = $(tcxml).find('tcPr')
                                    // console.log(tr[b].tc[a].tcPr,tcPrxml)

                                }else if(x.tagName=='p'){
                                    tempHtml += `${that.p(xmlToJson(x),x)}`
                                }
                            }
                        tempHtml += `</td>`
                    }
                    tempHtml += "</tr>"
                }
            }
        }
        return `<table class="table table-bordered">${tempHtml}</table>`;
     }
};
var wF2 = {
    main: function(obj){ //console.log(obj,xmlToJson(obj));
      // store all bookmarks
        bookmarks = getAllBookmarks(obj); //console.log(bookmarks)
      // process firsts: body>
        //*************** */
        var tempHtml = "";
        firsts = $(obj).find('body>'); ////console.log({firsts}); // get first children in "body"
        for(var c=0;c<firsts.length;c++){
            para = c
            first = firsts[c]; //console.log(first)
            if (typeof wF2[first.tagName] == "function"){ // p,r,pPr,tbl
                //console.log('handled',first.tagName)
                //*************** */
                tempHtml += this[first.tagName](xmlToJson(first),first);
            }else{
                //console.log('not handled first:',first.tagName, first)
            }
        }
        //*************** */
        return tempHtml;
     },
    p: function(p,xml){ //console.log('p',p,$(xml).find('>'))
        // var start = performance.now()
        var xs = $(xml).find('>');
        //********************** */
        var html = "";
        var spans = [];
        var pStyle="";
        var rStyle="";
        var anchor="";
        var tooltip="";
        var t="";
        var link="";
        var bookmarkid="";
        var bookmarkname="";
        var span="";
        var temp="";
        var $x = "";
        var rId = ""
        var rel = {}
        var target = ""
        for(var x of xs){  //console.log('p>',x)
            $x = $(x)
            if(x.tagName=='pPr'){ // process "pPr"
                /* get Paragraph style */
                pStyle  = $x.find('pStyle').attr('val')||'' // get pStyle
                rStyle  = $x.find('rPr>rStyle').attr('val')||'' // get rStyle
                /* check for list in pPr */
                thisStylePListlevel = $x.find('numPr').length>0
                if (thisStylePListlevel){
                    thisStylePListlevel = $x.find('numPr>numId').attr('val')+":"+$x.find('numPr>ilvl').attr('val')
                }

            }else if(x.tagName=='hyperlink'){ // process "hyperlink"
                anchor  = $x.attr('anchor')
                tooltip = $x.attr('tooltip')
                rStyle  = $x.find('r>rPr>rStyle').attr('val')||''
                t       = $x.find('r>t').text()
                link    = `<a href="${target?target:''}#${anchor}" class="Hyperlink ${rStyle}"${tooltip?` title="${tooltip}"`:``}>${t?`${t}`:``}</a>`
                spans.push(link) // create and add link to spans(p content)
                //console.log('x.hyperlink',x,link,rel)
                br='link';

            }else if(x.tagName=='bookmarkStart'){ // process "bookmarkStart"
                bookmarkid  = $x.attr('id')
                bookmarkname  = $x.attr('name')
                span   = `<span id="${bookmarkname}">`
                spans.push(span) // create and add bookmarkStart part (sometime bookmarkStart not in p)

            }else if(x.tagName=='bookmarkEnd'){ // process "bookmarkEnd"
                bookmarkid  = $x.attr('id')
                bookmarkname = bookmarks[bookmarkid]
                span   = `</span>`
                spans.push(span) // create and add bookmarkEnd (what if bookmarkStart not in p?)

            }else if(x.tagName=='r'){ // process "r"
                if (fldChar == true){
                    if($x.find('fldChar').attr('fldCharType')=='end'){
                        fldChar = false;
                        if(/HYPERLINK/.test(fldCharStr)){ //console.log('fldCharstr',xml,fldCharStr)
                            rStyle = $x.find('rPr>rStyle').attr('val')||defaultpPr.pStyle.attributes.val||'Normal'
                            // "HYPERLINK "\\\\NYINGMAMONLAM\\web\\YontenZod2018\\docx\\YontenZodSutra-Chabter01~08.docx" \l "A1023བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླ"གསུམ་པ་བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླབ་བྱའི་ལེའུ་བཤད་པ་ལ་གཉིས་ཏེ།"
                            // " HYPERLINK  \l "B730དང་པོ་ནི།" \o "དང་པོ་ནི།" བསླབ་པ་བསྲུང་ཐབས་བཤད་པ་དང་།"
                            var hrefDoc = ""
                            var href  = (temp = fldCharStr.split(/\\l "(.+?)"/),temp.length>1?temp[1]:'')
                            var title = (temp = fldCharStr.split(/\\o "(.+?)"/),temp.length>1?temp[1]:'')
                            var text  = (temp = fldCharStr.split(/" /),temp.length>1?temp.slice(-1)[0]:'')
                            console.log({bookmarkname,href,title,text})
                            spans.push(`<a para="${para-1}"${title?` title="${title}"`:''}${bookmarkname?` id="${bookmarkname}"`:''} href="${hrefDoc}#${href}" class="Hyperlink ${rStyle}">${text}</a>`);
                            fldCharStr=''
                        }else if(/INCLUDEPICTURE/.test(fldCharStr)){ console.log('INCLUDEPICTURE',fldCharStr)

                        }else{ console.log(fldCharStr)
                            fcs = / *(.+?) /.exec(fldCharStr) // get field char string name
                            if (unhandeled[fcs] == undefined){
                                console.log(172,'unhandled fldCharStr',fldCharStr)
                                unhandeled[fcs] = fcs
                            }
                        }
                    }else{
                        // not fldChar.End: temp+= instrText
                        var a = $x.find('t').text()||''
                        var b = $x.find('instrText').text()||''
                        fldCharStr += a+b
                    }
                }else{
                    // check for fldChar 'begin'
                        if ($x.find('fldChar').attr('fldCharType')=='begin'){
                            fldChar=true;
                            fldCharStr='';
                    // check for 'pict'
                        }else if ($x.find('pict').length>0){ // check for pict
                            var pictTitle = $x.find('v:shape.v:imagedata.attributes.o:title')
                            var pictStyle = $x.find('v:shape.attributes.style')
                            paraObj.push({
                                html: `<img style="${pictStyle}" src="${pictTitle}">`
                            })
                            tempHtml += `<img style="${pictStyle}" src="${pictTitle}">`;
                    // check for drawing
                        }else if ($x.find('drawing').length>0){ //console.log(x)
                            //console.log(obj)
                            // 2020-01-03 some doc have i think embeded pic: obj.drawing.v:rect..... need to add
                            // if obj.drawing is not v:shape ignore for now
                            // insert and link picture
                            var drawingTitle =
                                $x.find('pic\\:cNvPr').attr('name')||
                                $x.find('wp\\:inline>wp\\:docPr').attr('descr')||
                                $x.find('wp\\:inline>wp\\:docPr').attr('name')
                            if(!/^https/.test(drawingTitle)){
                                drawingTitle = "https://tulkuajam.org/images/"+drawingTitle
                            }
                            var drawingStyle = `width: ${(Number($x.find('wp\\:inline>wp\\:extent').attr('cx'))/9525).toFixed(3)}px;height: ${(Number($x.find('wp\\:inline>wp\\:extent').attr('cy'))/9525).toFixed(3)}px;`
                            //console.log(drawingTitle, drawingStyle)
                            if (drawingTitle && drawingStyle){
                                spans.push(`<img style="${drawingStyle}" src="${drawingTitle}">`);
                            }else{
                                console.log('drawing error', x , {drawingTitle}, {drawingStyle})
                            }
                    //  check for 'br>type' != ''
                        }else if ($x.find('br').attr('type')!=undefined){ //*** check for page break br ***//
                            spans.push('<hr>')
                    // else 'r'
                        }else{
                            // get rStyle
                                rStyle = $x.find('rPr>rStyle').attr('val')||defaultpPr.pStyle.attributes.val||'Normal'
                            // get t.#text
                                t      = $x.find('t').text()||''
                            // thisText is not empty
                                if (t != ''){
                                    spans.push(`<span class="${rStyle}">${t}</span>`);
                                    StyleList[rStyle] = rStyle;
                                    StyleList[pStyle] = pStyle;
                                }
                        }
                }
            }
        }

        if(thisStylePListlevel){
            // current pass = List>Span
                if(thisStylePListMode==false){
                    // current mode ParaSpan
                        // <ul><li>span</li>
                            html = `<ul>\n<li listlevel="${thisStylePListlevel}" class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</li>`;
                            thisStylePListMode=true; //ListSpan:start
                }else{
                    // current mode ListSpan
                        if(thisStylePListlevelLast == thisStylePListlevel){ ///?????
                            // current mode LS && thisStylePListlevelLast == thisStylePListlevel
                                // <li>span<li>       LS:mid
                                    html = `<li listlevel="${thisStylePListlevel}" class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</li>`;
                        }else{
                            // current mode LS && thisStylePListlevelLast != thisStylePListlevel
                                // </ul><ul>li>span<li> LS:mid:restart
                                    html = `</ul>\n<ul>\n<li listlevel="${thisStylePListlevel}" class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</li>`;
                        }
                }
        }else{
            // current pass = Para>Span
                if(thisStylePListMode==true){
                    // current mode LS
                        // </ul><p>span</p>   LS:end
                            thisStylePListlevelLast = false
                            thisStylePListMode = false
                            html = `</ul><p class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</p>`;
                }else{
                    // current mode PS
                        // <p>span</p>       PS
                            html = `<p class="${pStyle}">${spans.map(m=>m).join('')||'<br>'}</p>`;
                }
        }
        thisStylePListlevelLast = thisStylePListlevel
        // console.log(html)
        return html
     },
    r: function(obj){ //console.log('r',obj,obj.t?obj.t['#text']:obj.t)
        var tempHtml = ""
        if (obj.length == undefined){ var runs = [obj] }else{ runs = obj} // make array of 1 element
        for (var z = 0; z < runs.length; z++){
            obj = runs[z];
            if (fldChar == true){  // read fieldchar
                if ('end' == getValOf(obj,'fldChar.attributes.fldCharType')){  // check for fldChar 'end' // means end of field Char information
                    fldChar = false; // finished reading field Char information

                    // 2018-06-02 not all fieldchar are HYPERLINK checkfirst
                    //console.log(fldCharStr)

                    // if HYPERLINK
                    if (/HYPERLINK/.test(fldCharStr)){
                        thisStyleR = getValOf(obj,'rPr.rStyle.attributes.val')||defaultpPr.pStyle.attributes.val||'Normal'
                        // "HYPERLINK "\\\\NYINGMAMONLAM\\web\\YontenZod2018\\docx\\YontenZodSutra-Chabter01~08.docx" \l "A1023བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླ"གསུམ་པ་བསླབ་བྱ་ལ་སློབ་པ་སྨོན་འཇུག་བསླབ་བྱའི་ལེའུ་བཤད་པ་ལ་གཉིས་ཏེ།"
                        // " HYPERLINK  \l "B730དང་པོ་ནི།" \o "དང་པོ་ནི།" བསླབ་པ་བསྲུང་ཐབས་བཤད་པ་དང་།"

                        var re = / *HYPERLINK +"(.+?)"| *\\l +"(.*?)"| *\\o +"(.*?)"/  //"xx"[1],\l[2],\o[7],restString[8]
                        var res = fldCharStr.split(re); console.log(fldCharStr,res)
                        thisHrefDoc = res[1]||''
                        // replace .docx to .html
                        thisHrefDoc = thisHrefDoc.replace('.docx','.html').replace(/[ ;:'\-—~]/g,"_");
                        // get docName by last element of thisHrefDoc
                        thisHrefDoc = thisHrefDoc.split('\\').slice(-1)[0];

                        // get thisHref usw
                        thisHref = res[2]||res[6]||''
                        tibText  = res[7]||res[2]||res[6]||''
                        thisText = res[8]||res[2]||res[6]||''

                        var a =  `<a para="${para-1}" ${lastIdName?`id="${lastIdName}"`:''} href="${thisHrefDoc}#${thisHref}" class="Hyperlink ${thisStyleR}">${thisText}</a>`
                        if (temp == ''){
                            tempHtml += a;
                        }else{
                            tempHtml += `<span class="${lastStyle}">${temp}${a}</span>`;
                            temp = "";
                        }

                        lastIdName=''
                        fldCharStr=''
                    // fi HYPERLINK
                    }else if(/INCLUDEPICTURE/.test(fldCharStr)){
                        console.log('INCLUDEPICTURE')
                        thisStyleR = getValOf(obj,'rPr.rStyle.attributes.val')||defaultpPr.pStyle.attributes.val||'Normal'

                        var re = / *INCLUDEPICTURE +"(.+?)"| *\\l +"(.*?)"| *\\o +"(.*?)"/  //"xx"[1],\l[2],\o[7],restString[8]
                        var res = fldCharStr.split(re)

                        thisHrefDoc = res[1]||''
                        // replace .docx to .html
                        thisHrefDoc = thisHrefDoc.replace('.docx','.html').replace(/[ ;:'\-—~]/g,"_");
                        // get thisHref
                        thisHref = res[1].split('\\').slice(-1)[0]||''
                        tibText  = ''
                        thisText = ''

                        tempHtml += `<p class="Hyperlink ${thisStyleR}"><img src="${thisHref}"></p>`

                        // lastIdName=''
                        fldCharStr=''

                    }else{
                        fcs = / *(.+?) /.exec(fldCharStr) // get field char string name
                        if (unhandeled[fcs] == undefined){
                            console.log(172,'unhandled fldCharStr',fldCharStr)
                            unhandeled[fcs] = fcs
                        }

                    }
                }else{
                    // not fldChar.End: temp+= instrText
                    var a = getValOf(obj,'t.#text')||''
                    var b = getValOf(obj,'instrText.#text')||''
                    fldCharStr += a+b
                }
            }else{ // fldChar!=true // not read fieldchar
                // check for fldChar 'begin'
                if ('begin' == getValOf(obj,'fldChar.attributes.fldCharType')){
                    fldChar=true;
                    fldCharStr='';

                }else if (getValOf(obj,'pict')){ // check for pict
                    var pictTitle = getValOf(pict,'v:shape.v:imagedata.attributes.o:title')
                    var pictStyle = getValOf(pict,'v:shape.attributes.style')
                    paraObj.push({
                        html: `<img style="${pictStyle}" src="${pictTitle}">`
                    })
                    tempHtml += `<img style="${pictStyle}" src="${pictTitle}">`;

                }else if ('' != getValOf(obj, 'br.attributes.type')){ //*** check for page break br ***//

                    tempHtml += `<span class="${lastStyle}">${temp}</span>`

                    lastStyle = thisStyleR
                    temp = thisText

                    tempHtml += '<hr>'

                }else{
                    // get rStyle
                    thisStyleR = getValOf(obj,'rPr.rStyle.attributes.val')||defaultpPr.pStyle.attributes.val||'Normal'
                    // get t.#text
                    thisText = getValOf(obj,'t.#text')||''
                    // thisText is not empty
                    if (thisText != ''){
                        if ((lastStyle == thisStyleR || lastStyle == "") && br == ''){ //if: same style add to temp || is empty (first time)
                            temp += thisText
                            thisText=''
                            lastStyle = thisStyleR
                        }else{ //lastStyle != thisStyle || lastStyle != ""
                            if(temp != ''){ // temp != ''
                                tempHtml += `<span class="${lastStyle}">${temp}</span>`
                            }
                                // prepare this part
                                lastStyle = thisStyleR;
                                temp = thisText;
                            //*******************************//
                        }
                        StyleList[thisStyleR] = thisStyleR;
                        StyleList[thisStyleP] = thisStyleP;
                    }
                }
            }
        }
        tempHtml += temp != ''?`<span class="${lastStyle}">${temp}</span>`:'';
        temp = "";
        StyleList[thisStyleR] = thisStyleR;
        StyleList[thisStyleP] = thisStyleP;
        // return `<p class="${thisStyleP}">${tempHtml}</p>`;
        return tempHtml;

     },
    mybookmarkEnd: function(bk){

        if(bk.length>0){
            for(var a=0;a<bk.length;a++){
                var id = getValOf(bk[a],'attributes.id')||''
                if(!/^_/.test(bookmarks[id])){
                    lastIdName = bookmarks[id];
                }
            }
        }else{
            var id = getValOf(bk,'attributes.id')||''
            if(!/^_/.test(bookmarks[id])){
                lastIdName = bookmarks[id];
            }
        }
        if (temp != ''){
            tempHtml += `<span class="${thisStyleR}">${temp}</span>`
            temp=''
            lastStyle = thisStyleR
        }
        return tempHtml||''
     },
    myhyperlink: function(Hyper) { console.log({Hyper}) // hyperlink
        var tempHtml = ""
        if (Hyper != undefined){
            // var Hyper = ee
            var mythisHrefDoc = ""
            var mythisHref    = getValOf(Hyper,'attributes.anchor')||''
            var mythisTooltip = getValOf(Hyper,'attributes.tooltip')||''
            var mythisText    = ""
            var mythisStyleR  = ""
            if(Hyper.r.length>0){
                mythisStyleR      = getValOf(Hyper.r[0],'rPr.rStyle.attributes.val')||''
                for(var hr=0;hr<Hyper.r.length;hr++){
                    mythisText        += getValOf(Hyper.r[hr],'t.#text')||''
                }
            }else{
                mythisStyleR      = getValOf(Hyper,'r.rPr.rStyle.attributes.val')||''
                mythisText        = getValOf(Hyper,'r.t.#text')||''
            }
            // thisStyleR      = getValOf(Hyper,'r.rPr.rStyle.attributes.val')||''
            // thisText        = getValOf(Hyper,'r.t.#text')||''
        //***************** hyperlink  ************************************//
            tempHtml += `<a ${lastIdName?`id="${lastIdName}"`:''} href="${mythisHrefDoc}#${mythisHref}" class="${mythisStyleR}" title="${mythisTooltip}">${mythisText}</a>`
            lastIdName=""

            lastStyle=mythisStyleR
        //*****************            ************************************//
        }
        // console.log(tempHtml)
        return tempHtml;
     },
    // fake handler
    //sectPr: function(){},
    pPr: function(paraStyle){ //console.log(paraStyle);
        if (paraStyle.pStyle == undefined) { paraStyle.pStyle = { attributes:{val:"Normal"} } }
        defaultpPr = paraStyle
     },
    tbl: function(tbl){ console.log(tbl)
        var that = this;
        var tempHtml = ""
        var table = {}

        for (v in tbl){
            if (v == 'tblPr'){
                tblPr = tbl[v]
                console.log(tblPr.tblW.attributes.w,(Number(tblPr.tblW.attributes.w)/567).toPrecision(3)+"cm")
                table.width = (Number(tblPr.tblW.attributes.w)/567).toPrecision(3)+"cm"
                //console.log(tblPr)

            }else if (v == 'tblGrid'){
                tblGrid = tbl[v];
                table.colWidths = tblGrid.gridCol.map(function(v){
                    console.log(v.attributes.w,(Number(v.attributes.w)/567).toPrecision(3)+"cm");
                    return (Number(v.attributes.w)/567).toPrecision(3)+"cm"
                })
                //console.log(tblGrid)

            }else if (v == 'tr'){
                tr = tbl[v] //trs

                for (var b=0;b<tr.length;b++){ // tr
                    tempHtml += "<tr>"
                    for (var a=0;a<tr[b].tc.length;a++){ // tc=td
                        // console.log(tr[b].tc[a])

                        if(tr[b].tc[a].bookmarkStart != undefined){
                            this.bookmarkStart(tr[b].tc[a].bookmarkStart) //console.log(p.bookmarkStart.attributes.name,lastIdName)
                        }
                        var ps = tr[b].tc[a].p
                        if (ps.length>0){
                            // feed p one by one if is array
                            tempHtml += `<td style="width:${table.colWidths[a]}">`
                            for (var c=0;c<ps.length;c++){
                                tempHtml += `${that.p(ps[c])}`
                            }
                            tempHtml += `</td>`
                        }else{
                            tempHtml += `<td style="width:${table.colWidths[a]}">${that.p(ps)}</td>`
                        }
                    }
                    tempHtml += "</tr>"
                }

            }
        }
        return `<table class="table table-bordered">${tempHtml}</table>`;
     }
};
// if(module.exports){
    module.exports = {wF, wF2, StyleList, styleJsonToCss,styleJsonToCss2}
// }
// export {wF, StyleList, styleJsonToCss2}